module.exports = __webpack_public_path__ + "static/missed.65a32412.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/missed.gif
// module id = 465
// module chunks = 162898551421021